import React from 'react';
import PropTypes from 'prop-types';
import { BOARD_WIDTH, BOARD_HEIGHT } from '../constants';
import Walls from './Walls';
import './style.scss';
export default function Board(props) {
  var gridSize = props.gridSize;
  var boardWidth = gridSize * BOARD_WIDTH;
  var boardHeight = gridSize * BOARD_HEIGHT;
  return /*#__PURE__*/React.createElement("div", {
    className: "pacman-board"
  }, /*#__PURE__*/React.createElement("svg", {
    width: boardWidth,
    height: boardHeight
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: boardWidth,
    height: boardHeight,
    fill: "#000"
  }), /*#__PURE__*/React.createElement(Walls, props)));
}
Board.propTypes = {
  gridSize: PropTypes.number.isRequired
};